interface Props {
  disabled?: boolean
  name?: string
  label: string
  options: {
    id: string
    label: string
    value: string
    hasInput?: boolean
    inputPlaceholder?: string
    inputValue?: string
    inputOnChange?: (value: string) => void
    inputWidth?: string | number
    inputUnit?: string
  }[]
  checked?: any
  onChange?: (value: any) => void
}

const RadioInput: React.FC<Props> = ({  disabled, name, label, options, checked, onChange }) => {
  return (
    <>
      <div className='row'>
        <div className='col-12 col-xl-3'>
          <span className='fs-6 me-10 fw-bold'>{label}:</span>
        </div>

        <div className='col-12 col-xl-9'>
          <div
            className='d-flex flex-column flex-xl-row align-items-xl-center'
            style={{ gap: '12px' }}>
            {options.map((o, idx) => (
              <div
                key={`${label}-${o.id}-${idx}`}
                className='form-check align-items-center d-flex flex-row h-30px'
                style={{ columnGap: '12px' }}>
                {checked !== undefined ? (
                  <input
                    name={name}
                    id={o.id}
                    type='radio'
                    className='form-check-input'
                    value={o.value}
                    checked={checked === o.value}
                    onChange={(e: any) => {
                      if (onChange) onChange(e.currentTarget.value)
                    }}
                    disabled={disabled}
                  />
                ) : (
                  <input id={o.id} type='radio' className='form-check-input' checked={idx === 0} />
                )}

                <label htmlFor={o.id} className='text-grey-700'>
                  <span className='d-inline-block'>{o.label}</span>

                  {o.hasInput && (
                    <div className='ms-2 radio-input position-relative'>
                      <input
                        name={name ? name + '-input' : 'input'}
                        type='text'
                        className={`form-control form-control-sm h-30px w-${
                          o.inputWidth ? o.inputWidth : 400
                        }px`}
                        style={{ minHeight: 0 }}
                        placeholder={o.inputPlaceholder}
                        value={o.inputValue}
                        onChange={(e: any) =>
                          o.inputOnChange && o.inputOnChange(e.currentTarget.value)
                        }
                        disabled={disabled}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        {o.inputUnit}
                      </div>
                    </div>
                  )}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
          .radio-input {
            display: inline-block !important;
          }
        `}</style>
    </>
  )
}

export default RadioInput
